import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { CardContent, Grid, Link, Typography } from '@mui/material';
import { EmployersTable, EmployersToolbar } from '../../Components';
import { ViewDialog } from 'app/components/ViewDialog';
import { faFileArrowUp, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import { useBreadcrumb } from 'app/components/Breadcrumbs';
import { CardStyled, DivContentStyled, FontAwesomeIconStyled, TypographyStyled } from './EmployerManagementPage.styles';
import { EmployerUploadFormDialog } from './EmployerUploadFormDialog';
import { useEmployerManagementPage } from './useEmployerManagementPage';

export const EmployerManagementPage = () => {
  const {
    employers,
    totalItems,
    isFetching,
    page,
    pageSize,
    searchQuery,
    createEmployerModalOpen,
    showEmployerUploadFormDialog,
    handleSearch,
    handlePageChange,
    handleSortChange,
    openCreateEmployerModal,
    closeCreateEmployerModal,
    openEmployerUploadFormDialog,
    closeEmployerUploadFormDialog,
  } = useEmployerManagementPage();

  useBreadcrumb('menu.employers', {
    hideTrail: true,
    hideTitle: true,
    otherElements: (
      <EmployersToolbar
        handleClickAdd={useCallback(openCreateEmployerModal, [openCreateEmployerModal])}
        handleSearch={handleSearch}
        totalCount={isFetching ? undefined : totalItems}
        initialSearchQuery={searchQuery}
      />
    ),
  });

  return (
    <div>
      <DivContentStyled>
        <EmployersTable
          onPaginationChange={handlePageChange}
          employers={employers}
          totalCount={totalItems}
          page={page}
          rowsPerPage={pageSize}
          loading={isFetching}
          onSortChange={handleSortChange}
        />
      </DivContentStyled>

      {createEmployerModalOpen && (
        <ViewDialog
          closeButton={false}
          open={createEmployerModalOpen}
          setOpen={closeCreateEmployerModal}
          title={<FormattedMessage id="employers.add" />}
          onClose={closeCreateEmployerModal}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CardStyled>
                <CardContent>
                  <Link href={'/employers/add'}>
                    <FontAwesomeIconStyled icon={faHandPointer} />
                    <TypographyStyled variant="h5">
                      <FormattedMessage id="employers.add.manually" />
                    </TypographyStyled>
                    <Typography variant="body1">
                      <FormattedMessage id="employers.add.manually.description" />
                    </Typography>
                  </Link>
                </CardContent>
              </CardStyled>
            </Grid>
            <Grid item xs={6}>
              <CardStyled onClick={openEmployerUploadFormDialog}>
                <CardContent>
                  <Link href="#">
                    <FontAwesomeIconStyled icon={faFileArrowUp} />
                    <TypographyStyled variant="h5">
                      <FormattedMessage id="employers.add.fileUpload" />
                    </TypographyStyled>
                    <Typography variant="body1">
                      <FormattedMessage id="employers.add.fileUpload.description" />
                    </Typography>
                  </Link>
                </CardContent>
              </CardStyled>
            </Grid>
          </Grid>
        </ViewDialog>
      )}
      {showEmployerUploadFormDialog && (
        <EmployerUploadFormDialog
          show={showEmployerUploadFormDialog}
          onClose={closeEmployerUploadFormDialog}
          afterSubmit={closeEmployerUploadFormDialog}
        />
      )}
    </div>
  );
};
